import { Input, Select } from '../common/Input';

interface Props {
  search: string;
  onSearchChange: (v: string) => void;
  statusFilter: string;
  onStatusFilterChange: (v: string) => void;
  tagFilter: string;
  onTagFilterChange: (v: string) => void;
  tags: string[];
}

const statuses: { value: string; label: string }[] = [
  { value: '', label: 'All statuses' },
  { value: 'up', label: 'Operational' },
  { value: 'down', label: 'Down' },
  { value: 'degraded', label: 'Degraded' },
  { value: 'pending', label: 'Pending' },
  { value: 'maintenance', label: 'Maintenance' },
];

export function FilterBar({
  search, onSearchChange,
  statusFilter, onStatusFilterChange,
  tagFilter, onTagFilterChange,
  tags,
}: Props) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 flex-1 min-w-0">
      <Input
        type="search"
        placeholder="Search services…"
        value={search}
        onChange={e => onSearchChange(e.target.value)}
        aria-label="Search services"
        className="flex-1"
      />
      <Select
        value={statusFilter}
        onChange={e => onStatusFilterChange(e.target.value)}
        aria-label="Filter by status"
        className="sm:w-auto"
      >
        {statuses.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
      </Select>
      {tags.length > 0 && (
        <Select
          value={tagFilter}
          onChange={e => onTagFilterChange(e.target.value)}
          aria-label="Filter by tag"
          className="sm:w-auto"
        >
          <option value="">All tags</option>
          {tags.map(t => <option key={t} value={t}>{t}</option>)}
        </Select>
      )}
    </div>
  );
}
